import script from "./WhatsAppConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppConfig.vue?vue&type=script&setup=true&lang=js"

import "./WhatsAppConfig.vue?vue&type=style&index=0&id=0c73eb44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c73eb44"]])

export default __exports__